module.exports = __webpack_public_path__ + "img/cardActivation.4257fda4.png";